import styled from 'styled-components';
import { POPOVER_MAX_CONTENT_WIDTH } from './consts';

/**
 * Card body for a truncation popover that reveals a clipped label's full text.
 * Wraps long content instead of overflowing the card.
 */
export const TruncationPopoverContent = styled.div`
  max-width: ${POPOVER_MAX_CONTENT_WIDTH}px;
  white-space: normal;
  overflow-wrap: anywhere;
`;
